<template>
  <div class="container my-5">
    <div class="row">
      <div class="col12 actions">
        <button
        type="button"
        class="btn btn-primary mt-2 mt-xl-0 float-end"
        v-c-modal:modal="{}"
      >
        <i class="far fa-plus"></i> Aws Account
      </button>
      </div>
    </div>
    

    <c-data-list ref="dataList" :items="awsAccounts">
        <template v-slot:columns>
          <div class="col-12 col-lg-2 col-xl-2">
            <p>Aws Account Id</p>
          </div>
          <div class="col-12 col-lg-3 col-xl-3">
            <p>Name</p>
          </div>
          <div class="col-6 col-lg-3 col-xl-3">
            <p>Terraform workspace name</p>
          </div>
          <div class="col-6 col-lg-2 col-xl-2 text-end">Charge</div>
          <div class="col-6 col-lg-2 col-xl-2 text-end"></div>
        </template>
        <template v-slot:default="slotProps">
          <aws-account-list-item :account="slotProps.item" @someEvent="clicked" />
        </template>
      </c-data-list>

    <aws-account-modal
      ref="modal"
      @created="newAwsAccountCreated"
      title="Add Aws Account"
      :awsAccount="newAwsAccount"
    ></aws-account-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

import AwsAccountModal from "./aws-accounts/AwsAccountModal";
import AwsAccountListItem from "./aws-accounts/AwsAccountListItem"
import AwsAccountModel from "./../../models/aws-account";

export default {
  $_veeValidate: {
    validator: "new", // give me my own validator scope.
  },
  components: {
    AwsAccountModal,
    AwsAccountListItem
  },
  data: function () {
    return {
      loaded: false,
      newAwsAccount: new AwsAccountModel()
    };
  },
  computed: {
    ...mapState("stack", {
      stack: "single",
    }),
    ...mapState("stack/awsAccount", {
      awsAccount: "single",
      awsAccounts: "list"
    })
  },
  mounted: function () {
    this.getAwsAccounts();
  },

  methods: {
    ...mapActions("stack", {
      getStack: "getSingle",
      updateSingle: "updateSingle",
      deleteSingle: "deleteSingle",
    }),
    ...mapActions("stack/awsAccount", {
      getAwsAccounts: "getList"
    }),

    newAwsAccountCreated() {
      this.getAwsAccounts()
    },

    clicked(a){
      console.log('clicked', a)
    },

    confirmDelete() {
      this.$swal({
        title: "Confirm Delete",
        html: "Are you sure you want to delete this stack",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Delete",
      }).then(
        () => {
          this.deleteSingle(this.stack.id).then(
            this.$router.push({ name: "stacks.index" })
          );
        },
        function () {}
      );
    },
  },
};
</script>
